// extracted by mini-css-extract-plugin
export var icon = "_6z-1";
export var subtext = "_6z-0";